import { VueAgile } from '@webcase/vue-slider'

import { Tabs, Tab } from 'vue-slim-tabs'

// add chat component
import AddChat from '@app/Seller/Chats/Add'

import {
  PrettyStars,
} from './Stars.js'

import SellerRateInformation from './SellerRateInformation'
import SellerRate from './SellerRate'
import LightBox from './LightBox'
import LoaderBtn from './LoaderBtn'
import ModalTrigger from './ModalTrigger'
import NotPermission from './NotPermission'
import DateFormat from './DateFormat'
import SellerCatalog from './SellerCatalog'
import MegaMenu from './Header/MegaMenu'
import MegaMenuWrap from './Header/MegaMenuWrap'
import MegaMenuSafe from './Header/MegaMenuSafe'
import UserAccountActions from './Header/UserAccountActions'
import AdditionalLinks from './Header/AdditionalLinks'
import WaitingListGetter from './Header/WaitingListGetter'
import ShareBySms from './ShareBySms'
import UnSeoText from './UnSeoText'
import UnReadMore from './UnReadMore'
import UnAccordion from './UnAccordionUi'
import UnClickOutside from './UnClickOutside'
import UnShareBySms from './UnShareBySms'
import UnTabUi from './Tabs/UnTabUi'
import UnTabsUiHorizontal from './Tabs/UnTabsUiHorizontal'
import UnTabsUiVerticalUpdate from './Tabs/UnTabsUiVerticalUpdate'
import UnStepComponent from './UnStepComponent'
import ContentToggler from './ContentToggler'
import ShopInfo from './ShopInfo'

const SpecialInformation = () => import('./SpecialInformation')
const UnSpecialInformation = () => import('./UnSpecialInformation')
const UiSidebar = () => import('./Header/UiSidebar')
const UiSearch = () => import('./Header/UiSearch')
const CityChange = () => import('./Header/CityChange')
const CityChangeElement = () => import('./Header/CityChangeElement')
const TreeMenuTrigger = () => import('./Header/TreeMenuTrigger')
const NativeSearch = () => import('./NativeSearch')
const SeoText = () => import('./SeoText')
const UiSlider = () => import('./UiSlider')
const UiLoader = () => import('./UiLoader')
const UiMap = () => import('./UiMap')
const Toggler = () => import('./Toggler')
const UiYoutubeView = () => import('./UiYoutubeView')
const LangSwitcher = () => import('./LangSwitcher')
const UiTable = () => import('./UiTable')
const SellerInfo = () => import('./SellerInfo')

export function install(Vue) {
  Vue.component('LoaderBtn', LoaderBtn)
  Vue.component('WaitingListGetter', WaitingListGetter)
  Vue.component('DateFormat', DateFormat)
  Vue.component('UserAccountActions', UserAccountActions)
  Vue.component('NotPermission', NotPermission)
  Vue.component('SellerRateInformation', SellerRateInformation)
  Vue.component('UiMap', UiMap)
  Vue.component('CityChange', CityChange)
  Vue.component('CityChangeElement', CityChangeElement)
  Vue.component('TreeMenuTrigger', TreeMenuTrigger)
  Vue.component('LightBox', LightBox)
  Vue.component('ModalTrigger', ModalTrigger)
  Vue.component('SellerInfo', SellerInfo)
  Vue.component('ShareBySms', ShareBySms)
  Vue.component('UnAccordion', UnAccordion)
  Vue.component('UnClickOutside', UnClickOutside)
  Vue.component('UnShareBySms', UnShareBySms)
  Vue.component('SellerRate', SellerRate)

  Vue.component('ShopInfo', ShopInfo)
  Vue.component('SeoText', SeoText)
  Vue.component('ContentToggler', ContentToggler)
  Vue.component('PrettyStars', PrettyStars)
  Vue.component('NativeSearch', NativeSearch)
  Vue.component('UiSidebar', UiSidebar)
  Vue.component('UiSlider', UiSlider)
  Vue.component('UiLoader', UiLoader)
  Vue.component('UiSearch', UiSearch)
  Vue.component('VueAgile', VueAgile)
  Vue.component('Toggler', Toggler)
  Vue.component('UiYoutubeView', UiYoutubeView)
  Vue.component('LangSwitcher', LangSwitcher)
  Vue.component('UiTable', UiTable)
  Vue.component('Tabs', Tabs)
  Vue.component('Tab', Tab)
  Vue.component('UnSeoText', UnSeoText)
  Vue.component('AddChat', AddChat)
  Vue.component('MegaMenu', MegaMenu)
  Vue.component('MegaMenuWrap', MegaMenuWrap)
  Vue.component('MegaMenuSafe', MegaMenuSafe)
  Vue.component('AdditionalLinks', AdditionalLinks)
  Vue.component('SpecialInformation', SpecialInformation)
  Vue.component('UnSpecialInformation', UnSpecialInformation)
  Vue.component('UnReadMore', UnReadMore)
  Vue.component(SellerCatalog.name, SellerCatalog)
  Vue.component(UnTabUi.name, UnTabUi)
  Vue.component(UnTabsUiHorizontal.name, UnTabsUiHorizontal)
  Vue.component(UnStepComponent.name, UnStepComponent)
  Vue.component(UnTabsUiVerticalUpdate.name, UnTabsUiVerticalUpdate)
}

export default { install }
